import {Comment} from "./comment";
import {useTranslation} from "react-i18next";

export const CommentList = ({comments, editComment, deleteComment}) =>{
  const { t } = useTranslation();

    return <div className="commentList">
        <p className={'commentTitle'}>{t('Commentaires')} : </p>
        {
            comments.map((comment) =>
              <Comment key={comment.id} comment={comment} editComment={editComment} deleteComment={deleteComment} />
            )
        }
    </div>
}
